import { withStyles, createStyles, Theme, TableRow } from '@material-ui/core';

export const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {},
  }),
)(TableRow);
